import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core'

@Component({
    selector: 'app-modal-options-partner-down',
    templateUrl: './modal-options-partner-down.component.html',
    styleUrls: ['./modal-options-partner-down.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModalOptionsPartnerDownComponent implements OnInit {
  constructor() {}

  @Input() additionalClasses = ''
  @Input() isMobile = false
  @Input() mobileNumber = ''
  @Output() closeModalEvent: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()


  close() {
    this.closeModalEvent.emit(true)
  }

  ngOnInit(): void {
    this.toggleLoader.emit(false)
  }

}
